module.exports = __webpack_public_path__ + "img/LATIN10_08.6feaf295.jpg";